export const PATIENT_FIELD_RETRIEVED = "PATIENT_FIELD_RETRIEVED";
export const PRESCRIPTION_FIELD_RETRIEVED = "PRESCRIPTION_FIELD_RETRIEVED";
export const FREE_SHIPPING_SETTINGS_RECEIVED =
  "FREE_SHIPPING_SETTINGS_RECEIVED";
export const SCHOOL_RETRIEVED = "SCHOOL_RETRIEVED";
export const DATE_FORMAT_APPLIED = "DATE_FORMAT_APPLIED";
export const REMEMBER_SETTINGS_RECEIVED = "REMEMBER_SETTINGS_RECEIVED";
export const PICKUP_ADDRESS_RECEIVED = "PICKUP_ADDRESS_RECEIVED";
export const COMMISSION_SETTING_INFO_RECEIVED =
  "COMMISSION_SETTING_INFO_RECEIVED";
export const FAQ_RETRIEVED = "FAQ_RETRIEVED";
